import React from 'react';
import {
  components,
  GroupBase,
  MultiValueGenericProps,
} from 'react-select';

function MultiValueContainer<T, IsMulti extends boolean, Group extends GroupBase<T>>(
  props:MultiValueGenericProps<T, IsMulti, Group>,
): JSX.Element {
  return (
    <components.MultiValueContainer {...props}>
      {props.data.label}
    </components.MultiValueContainer>
  );
}

export default MultiValueContainer;
